// AIController.jsx
import React, { useState, useContext, useEffect, useRef } from 'react';
import gameBoard from './GameBoard'; // Adjust the path as per your file structure
import { PlayersDataExport } from './GameBoard';
import { currentPhaseExport } from './GameBoard';

import { territoryBoardDataExport } from './GameBoard';
import { linkingTerritoriesExport } from './GameBoard';
import { currentTurnPlayerExport } from './GameBoard';

import { updateTerritoryDataExport, updatePlayerDataExport, movePhaseExport, setCurrentGameStateExport, removeTerritoryFromOtherPlayersExport, rollDiceExport, restoreAttackTimerExport, phaseTimerExport } from './GameBoard';
import { isBattleScreenClosedExport, handleZIndexChangeExport, initializeBattleScreenDataExport, BattleDataExport } from './BattleScreen';
import BattleScreen from './BattleScreen';
import {  attackerDiceNumberExport, defenderDiceNumberExport, battleResultDataExport } from './GameBoard';
import { setAttackerDiceNumberExport, setDefenderDiceNumberExport } from './GameBoard';
import { isLogModeOnExport } from './GameBoard';


// Players Profile;
import {playerProfile1, playerProfile2, playerProfile3} from './GameBoard';

import { ScreenContext } from './App';


let executeBotAIExport;
let updateAIActiveStatusExport;



const AIController = () => {


    let stopExecution = false;
    const [isAIActive, setIsAIActive] = useState(null); // claimPhaseTimer
 
    useEffect(() => {
      if (isAIActive) {
        console.log('AI set to active.');
        // Perform additional actions when AI is active
      } else {
        console.log('AI set to inactive.');
        // Perform additional actions when AI is inactive
      }
    }, [isAIActive, !isAIActive]);

    if(isLogModeOnExport){
      console.log('AI Controller Script Loaded');
    }
    
  
    const updateAIActiveStatus = () => {
      console.log(`AI Active Status Changed`);
      if(isAIActive){
        console.log(`AI Active Status Changed to Inactive`);
        setIsAIActive(false);
        stopExecution = true;
      }else{
        console.log(`AI Active Status Changed to active`);
        setIsAIActive(true);
      }
    }

    //=====================================>
    // Function to execute bot AI
    //=====================================>
    const executeBotAI = (aiPlayerIndex, isCLAIM, occupyTroopCount, executionTime = 1, claimTime = 2) => {


      console.log(`Is AI Active ====> ${isAIActive}`);
      if(isAIActive === false){
        console.log(`AI is Not Active || returning Back`);
        return;
      }

      if(stopExecution === true){
        console.log(`Execution is Stopped || returning Back`);
        return;
      }

      if(isLogModeOnExport){
        console.log(`%c isCLAIM State ====> ${isCLAIM}`, 'color: green');
      }

      setTimeout(() => {
        if (isCLAIM) {
          if(isLogModeOnExport){
           
          }

          console.log('CLAIM STATE HANDLE');
            
          handleClaimState(aiPlayerIndex, occupyTroopCount, claimTime); //AIController.
        } else {
          
          if(currentTurnPlayerExport == 1){
            return;
          }
          if(isLogModeOnExport){
            console.log('OTHER STATE HANDLE');
          }
          handleOtherGameStates(aiPlayerIndex); //AIController.
        }
      }, 1000 * executionTime);
    };

    //=====================================>
    // Handle Claim State
    //=====================================>
    const handleClaimState = (aiPlayerIndex, occupyTroopCount, claimTime) => {

     // console.log(`Handle Claim State ====> AI Player Index ${aiPlayerIndex} || Current Player Turn ===> ${currentTurnPlayerExport}`);
      const playerList = [...PlayersDataExport];
      let claimableTerritories = territoryBoardDataExport.filter(territory => territory.territoryRuler === '');

      // Check if there are no claimable territories
      if (claimableTerritories.length <= 0) {
        const currentPlayerName = `Player${currentTurnPlayerExport}`;
        claimableTerritories = territoryBoardDataExport.filter(territory => territory.territoryRuler === currentPlayerName);
      }

      // Select a random claimable territory
      let randomTerritory;
      if (claimableTerritories.length > 0) {
        const randomIndex = Math.floor(Math.random() * claimableTerritories.length);
        randomTerritory = claimableTerritories[randomIndex];
      }

     

    //  console.log(` %c AI ${currentTurnPlayerExport - 1} || Reserved Troops Count ====> ${playerList[currentTurnPlayerExport - 1].reservedTroopsCount}`, 'color: green');
      if (playerList[currentTurnPlayerExport - 1].reservedTroopsCount <= 0) {
        
      //  movePhaseExport();
       // return;
      }

      // Update territory data
      const previousCounter = randomTerritory.troopsCount || 0;
      const troopsCount = previousCounter + occupyTroopCount;
      
      const updatedTerritory = { ...randomTerritory, territoryRuler: `Player${currentTurnPlayerExport}`, troopsCount };
      updateTerritoryDataExport(randomTerritory.id, updatedTerritory);
     // console.log(`Updated Territory Name ====> ${updatedTerritory.territoryName} ||  Updated Territory Data ====> ${JSON.stringify(updatedTerritory)}`);

      // Update player data
      if (!playerList[currentTurnPlayerExport - 1].occupiedTerritories.includes(randomTerritory.id)) {
        playerList[currentTurnPlayerExport - 1].occupiedTerritories.push(randomTerritory.id);
      }
      //playerList[currentTurnPlayerExport - 1].occupiedTerritories.push(randomTerritory.id);
      playerList[currentTurnPlayerExport - 1].lastOccupiedTerritory = randomTerritory.id;
      playerList[currentTurnPlayerExport - 1].reservedTroopsCount -= 1;
      playerList[currentTurnPlayerExport - 1].deployedTroopsCount += 1;
      if(isLogModeOnExport){
        console.log('<================= Update Players Data Called =================> ');
      }
      updatePlayerDataExport(currentTurnPlayerExport - 1, playerList[currentTurnPlayerExport - 1]);

      if(currentTurnPlayerExport -1 == 2){
       // console.log(`Player 2 Reserved TroopsCount ====> ${playerList[currentTurnPlayerExport - 1].reservedTroopsCount}`);
      }

     // if(playerList[currentTurnPlayerExport - 1].reservedTroopsCount != 0){
       // console.log(`Move Phase Timeout Set`);
        setTimeout(() => {
          movePhaseExport();
        }, 2000 * claimTime); // 2 seconds delay */
     // }

    };

    //=====================================>
    // Handle Other State
    //=====================================>
    const handleOtherGameStates = (aiPlayerIndex) => {

      if(isLogModeOnExport){
        console.log(`<============== Game State Phase: ${currentPhaseExport}`);
      }
      
      // Handle other game states (e.g., Reinforcement, Attack, Fortify)

      if (currentPhaseExport === 'Reinforcement') {

        const currentPlayerName = "Player" + currentTurnPlayerExport;
        let reinforceableTerritories = territoryBoardDataExport.filter(territory => territory.territoryRuler === currentPlayerName);

       // let reinforceableTerritories = getFortifiableOrAttackableTerritories(currentPlayerName, false, true);

       // console.log(`Reinforceable Terriories Data ====> ${JSON.stringify(reinforceableTerritories)}`);

       // return;

        const randomNumber = Math.floor(Math.random() * reinforceableTerritories.length);
        const targetReinforceableTerriotory = reinforceableTerritories[randomNumber];
        const reninforcementTroopsCount = Math.floor(PlayersDataExport[currentTurnPlayerExport - 1].occupiedTerritories.length / 3);
        performReinforcement(targetReinforceableTerriotory, reninforcementTroopsCount, false); // AIController.
       
      } else if (currentPhaseExport === 'Attack') {

        if(isLogModeOnExport){
          console.log("Current AI Turn Phase ==== Attack Phase");
        }
        const currentPlayerName = "Player" + currentTurnPlayerExport;
        let attackableTerritories = getFortifiableOrAttackableTerritories(currentPlayerName, true, false); // AIController.

        if(isLogModeOnExport){
          console.log('%cAttackable Territories Data: ' + JSON.stringify(attackableTerritories), 'color: red;');
        }

        const randomNumber = Math.floor(Math.random() * attackableTerritories.length);
        const targetAttackableTerriotory = attackableTerritories[randomNumber];

        if(isLogModeOnExport){
          console.log('%c Rondomly Picked Attackable Territories Data: ' + JSON.stringify(targetAttackableTerriotory), 'color: red;');
        }


        performAttack(aiPlayerIndex, targetAttackableTerriotory, 5, false); //AIController.

      } else {

        if(isLogModeOnExport){
          console.log("Current Turn Phase ==== Fortification Phase");
        }
        const currentPlayerName = "Player" + currentTurnPlayerExport;
        let fortifiableTerritories = getFortifiableOrAttackableTerritories(currentPlayerName, false, false); // AIController.

        const randomNumber = Math.floor(Math.random() * fortifiableTerritories.length);
        const targetfortifiableTerriotory = fortifiableTerritories[randomNumber];

        performFortify(targetfortifiableTerriotory, 5, false); // AIController.

      }
    };

    //=====================================>
    // Perform Reinforcement Attack
    //=====================================>
    const performReinforcement = (targetTerritory, troopsCount, isDefault) => {

    //  console.log("Perform Reinforcement Called");

     // console.log(`Target Reinforceable Terriotry ====> ${targetTerritory}`);

      if(targetTerritory == null){
        movePhaseExport();  
        return;
      }

      let territory = targetTerritory;
      let previousTroopsCount = territory.troopsCount || 0;
      previousTroopsCount += troopsCount;
      if(isLogModeOnExport){
        console.log(`%c AI Reinforcement Logic || Target Territory ====> ${territory.territoryName}|| Exiting Troops Count ====> ${territory.troopsCount} || Additonal Reinforcement Troops ====> ${troopsCount} || Current AI Player ====> ${currentTurnPlayerExport - 1}`, 'color: red');
      }
     //return;

      const actionTime = getRandomActionTimer();
    
      setTimeout(() => {

        const updatedTerritory = { ...territory, territoryRuler: `Player${currentTurnPlayerExport}`, troopsCount: previousTroopsCount };
        updateTerritoryDataExport(territory.id, updatedTerritory);
    
        const playerList = [...PlayersDataExport];
        if (!playerList[currentTurnPlayerExport - 1].occupiedTerritories.includes(targetTerritory.id)) {
          playerList[currentTurnPlayerExport - 1].occupiedTerritories.push(targetTerritory.id);
        }
        //playerList[currentTurnPlayerExport - 1].occupiedTerritories.push(targetTerritory.id);
        playerList[currentTurnPlayerExport - 1].lastOccupiedTerritory = (targetTerritory.id); 

        updatePlayerDataExport((currentTurnPlayerExport-1), playerList[currentTurnPlayerExport - 1]);

        setTimeout(() => {
          movePhaseExport();  
        }, 2000);
        

      }, actionTime); //

    };

    //===========================================>
    // Function to perform Attack by AI
    //===========================================>
    const performAttack = async (aiPlayerIndex, targetTerritory, troopsCount, isDefaultAttack) => {

      const attackableTerritories = [];
      let hasWonTerriotry;
    
      if(isLogModeOnExport){
       // console.log(`Perform Attack Called ====> Target Terriotry ====> ${JSON.stringify(targetTerritory)}`);
      }

      if(targetTerritory == null){
        console.log(`Attack Territory is Null || Moving to Next Phase`);
        
       // setTimeout(() => {
          
          movePhaseExport();

       // }, 2000); // 5 seconds delay */

        return;
      }

      let territoryOrigin = targetTerritory.associatedTerritory;
      targetTerritory = targetTerritory.attackableTerritory;
      let previousTroopsCount = targetTerritory.troopsCount || 0;

      if(isLogModeOnExport){
        console.log(`%cAI Attack Logic || Target Territory ====> ${JSON.stringify(targetTerritory)}|| Exiting Troops Count ====> ${previousTroopsCount} || Additonal Reinforcement Troops ====> ${troopsCount} || Origin Territory ====> ${JSON.stringify(territoryOrigin)}`, 'color: red');
       // return;
      }
    
      let attackOriginTroopCount = territoryOrigin.troopsCount || 0;
      attackOriginTroopCount = (attackOriginTroopCount - 1); 
      let playerName = null;
      let AIPlayerName = null;
      let hasWonBattle = false;

      let actionTime = getRandomActionTimer();

     // setTimeout(() => {   
       
      await new Promise(resolve => setTimeout(resolve, 1000));

        playerName = targetTerritory.territoryRuler;
        const playerIndex = playerName.slice(-1);
        const playerIndexInt = parseInt(playerIndex, 10);
        AIPlayerName = territoryOrigin.territoryRuler;

        const AttackingPlayerProfileImage =  AIPlayerName === 'Player1' ? playerProfile1 :  AIPlayerName === 'Player2' ? playerProfile2 : AIPlayerName === 'Player3' ? playerProfile3 : playerProfile2;
        const defendingPlayerProfileImage =  playerName === 'Player1' ? playerProfile1 :  playerName === 'Player2' ? playerProfile2 : playerName === 'Player3' ? playerProfile3 : playerProfile2;

        updateTerritoryDataExport(targetTerritory.id, {
          isTagetTerritory: true
        }); 

        await new Promise(resolve => setTimeout(resolve, 2000));

        if(playerName === 'Player1'){
          console.log(`[${new Date().toLocaleString()}] %c AI ${AIPlayerName} Attacked Player1`, 'color: green');
          await initializeBattleScreenDataExport(territoryOrigin, targetTerritory, AttackingPlayerProfileImage, defendingPlayerProfileImage);
          handleZIndexChangeExport(true);
        }
        
           
     // }, 1000);

      console.log(`[${new Date().toLocaleString()}] %c Execution Stopped for 1.5 seconds`, 'color: green');
      await new Promise(resolve => setTimeout(resolve, 1500));
      console.log(`[${new Date().toLocaleString()}] %c Execution Started Again`, 'color: green');

      if(playerName === 'Player1'){

        console.log(`[${new Date().toLocaleString()}] %c AI ${AIPlayerName} Attacked Local Player - Player1 || Battle Screen Status ====> ${isBattleScreenClosedExport}`, 'color: green');
        if (!isBattleScreenClosedExport) {

          while (!isBattleScreenClosedExport) {
          // Wait for 500 milliseconds before checking again
            await new Promise(resolve => setTimeout(resolve, 500));
          }
        }

        if(BattleDataExport.BattleStatus.winnerPlayer === territoryOrigin.territoryRuler){
          //console.log(`Attack has been won by player ${territoryOrigin.territoryRuler}`);
          hasWonBattle = true;
        }else{
          //console.log(`Attack has been lost by player ${territoryOrigin.territoryRuler}`);
          hasWonBattle = false;
        }

        actionTime = 2000;

      }else{

        console.log(`[${new Date().toLocaleString()}] %c AI ${AIPlayerName} Attacked AI Player`, 'color: red');

        const attackerDice = rollDice();
        const defenderDice = rollDice();

        if(attackerDice > defenderDice){

          hasWonBattle = true;

        }else{
          
          hasWonBattle = false;
          
        }

        actionTime = getRandomActionTimer();

      }

      // console.log(`%c Battle Screen Result ====> ${JSON.stringify(BattleDataExport)}` , 'color: red');
  
     // setIsBattling(false);

     console.log(`[${new Date().toLocaleString()}] %c Has Won Battle ====> ${hasWonBattle}`, 'color: red');

      if(!hasWonBattle){

        updateTerritoryDataExport(territoryOrigin.id, {
          troopsCount: 1,
        });
       
        setTimeout(() => {
          
          //console.log(`Battle Lost by AI player ${territoryOrigin.territoryRuler}`);
          movePhaseExport();
          
        }, 2000);
       
        return
      }

      
      //const updatedTroopsCount = previousTroopsCount + attackOriginTroopCount;

      const territory = territoryBoardDataExport.find(territory => territory.id === territoryOrigin.id);
      const updatedTroopsCount = territory.troopsCount - 1;
      setTimeout(() => {
  
        updateTerritoryDataExport(territoryOrigin.id, {
          troopsCount: 1,
        });
  
        console.log(` AI has won Battle || Updating Occupied Terrritory Data || has won Battle ${hasWonBattle}`);
        if(hasWonBattle){

          console.log(` AI has won Battle || Updating Occupied Terrritory Data `);
          updateTerritoryDataExport(targetTerritory.id, {
            troopsCount: updatedTroopsCount,
            territoryRuler: `Player${currentTurnPlayerExport}`
          });

          const playerList = [...PlayersDataExport];
          // Update player data
          if (!playerList[currentTurnPlayerExport - 1].occupiedTerritories.includes(targetTerritory.id)) {
            playerList[currentTurnPlayerExport - 1].occupiedTerritories.push(targetTerritory.id);
          }

          playerList[currentTurnPlayerExport - 1].lastOccupiedTerritory = targetTerritory.id;
          updatePlayerDataExport(currentTurnPlayerExport - 1, playerList[currentTurnPlayerExport - 1]);
          removeTerritoryFromOtherPlayersExport((currentTurnPlayerExport - 1), targetTerritory.id);

          restoreAttackTimerExport();

        }

        setTimeout(()=>{

          const randomAction = Math.floor(Math.random() * 2); 
          if(randomAction === 0){

            console.log('AI moved to fortify After Attack');
            movePhaseExport();

          }else{
            
            console.log('AI contieuing Attacking');
            if(phaseTimerExport < 15){

              console.log('Battle Time is less Attack || Moved to Next Phase');
              movePhaseExport();
            }else{

              executeBotAI(currentTurnPlayerExport, false, 0);

            }
           
          }
          
        }, 2000)

      }, actionTime);
    };

    //===========================================>
    // Function to perform perform Fortify by AI
    //===========================================>
    const performFortify = (targetTerritory, troopsCount, isDefaultAttack) => {

      //console.log(`%cAI Fortify Logic || Target Territory ====> ${JSON.stringify(targetTerritory)}`, 'color: green');
      

      if(targetTerritory == null){
        console.log(`Fortify Territory is Null`);
       // setTimeout(() => {

          movePhaseExport();  
          return;

       // }, 2000);

      }

      let territoryOrigin = targetTerritory.associatedTerritory;
      targetTerritory = targetTerritory.fortifiableTerritory;
      let previousTroopsCount = targetTerritory.troopsCount || 0;
    
      let fortifyOriginTroopCount = territoryOrigin.troopsCount || 0;
      const updatedTroopsCount = previousTroopsCount + (fortifyOriginTroopCount-1);
      fortifyOriginTroopCount = 1;

     // console.log(`%cAI Fortify Logic || Target Territory ====> ${JSON.stringify(targetTerritory)} || Target Origin Territory ====> ${JSON.stringify(territoryOrigin)} `, 'color: green');
     // return
      
     let actionTime = getRandomActionTimer();

      setTimeout(() => {
        updateTerritoryDataExport(targetTerritory.id, {
          troopsCount: updatedTroopsCount,
        });
  
        updateTerritoryDataExport(territoryOrigin.id, {
          troopsCount: fortifyOriginTroopCount,
        });
        

        setTimeout(() => {

          movePhaseExport();  

        }, 2000);

      }, actionTime); // 5 seconds delay */
  
    };   

    //#region Helper Methods
    function getRandomActionTimer(){

      const randomAmountTime =  Math.floor(Math.random() * 9) + 2;
      return randomAmountTime;

    }
    
    function rollDice() {
      // Generate a random number between 1 and 6
      return Math.floor(Math.random() * 6) + 1;
    }

    //===========================================>
    // Function to get 5 occupiable territories
    //===========================================>
    const getOccupiableTerritories = () => {

      const occupiableTerritories = [];
      collectOccupiableTerritories(1, new Set(), occupiableTerritories); //AIController.
     
      return occupiableTerritories.slice(0, 5);
    };

    //==========================================================>
    // Function to collect occupiable territories recursively
    //==========================================================>
    const collectOccupiableTerritories = (territoryIndex, visitedTerritories = new Set(), occupiableTerritories = []) => {
     
      if (visitedTerritories.has(territoryIndex)) {
        return;
      }
      
      visitedTerritories.add(territoryIndex);
      const linkedTerritories = linkingTerritoriesExport[territoryIndex];

      linkedTerritories.forEach((linkedTerritory) => {
        
        const territory = territoryBoardDataExport[linkedTerritory - 1];
        if (territory.territoryRuler === '' || territory.territoryRuler === 'Player2') {
  
          occupiableTerritories.push(territory);
        }
      
        collectOccupiableTerritories(linkedTerritory, visitedTerritories, occupiableTerritories); // AIController.
      })
    };

    //==========================================================>
    // Function to get Fortifiable Territories recursively
    //==========================================================>
    const getFortifiableOrAttackableTerritories = (currentPlayer, isAttack, isReinforcment) => {
      const fortifiableTerritories = [];

     // console.log(`Player Name ====> ${currentPlayer } || isAttack  ====> ${isAttack}`);
    
      PlayersDataExport.forEach((player) => {
        if (player.playerName === currentPlayer) {

         // console.log(`Player Data ====> ${JSON.stringify(player)}`);
          let filteredTerritories = player.occupiedTerritories; //occupiedTerritories.filter(id => id !== null);
          filteredTerritories = filteredTerritories.filter((id, index, self) => id !== null && self.indexOf(id) === index);

         // console.log(`Filtered Terriotry Data ====> ${filteredTerritories}`);
          filteredTerritories.forEach((territoryId) => {
              
            if(territoryId === null){
              return;
            }
            const linkedTerritories = linkingTerritoriesExport[territoryId];
           // console.log(`Territory ID ====> ${territoryId}`);
           // console.log(`Linked Territory ====> ${linkedTerritories}`);
           
            if (!linkedTerritories) {
              return; // Skip to the next iteration if linkedTerritories is null or undefined
            }
          
            linkedTerritories.forEach((linkedTerritoryId) => {
              const linkedTerritory = territoryBoardDataExport.find((territory) => territory.id === linkedTerritoryId);
    

              if(isReinforcment){

                if (linkedTerritory && linkedTerritory.territoryRuler !== currentPlayer && linkedTerritory.territoryRuler !== '') {

                  if (!linkedTerritory) {
                    return; // Skip to the next iteration if linkedTerritory is null or undefined
                  }

                  const foundTerritory = territoryBoardDataExport.find(
                    (territory) => territory.id === territoryId
                  );
    
                  if (foundTerritory) {

                    fortifiableTerritories.push({
                      attackableTerritory: linkedTerritory,
                      associatedTerritory: foundTerritory
                    });

                  }
                }
                
              }

              if (isAttack && !isReinforcment) {
                if (linkedTerritory && linkedTerritory.territoryRuler !== currentPlayer && linkedTerritory.territoryRuler !== '') {

                  const foundTerritory = territoryBoardDataExport.find(
                    (territory) => territory.id === territoryId && territory.troopsCount > 1
                  );
    
                  if (foundTerritory && foundTerritory.troopsCount > linkedTerritory.troopsCount) {

                    fortifiableTerritories.push({
                      attackableTerritory: linkedTerritory,
                      associatedTerritory: foundTerritory
                    });

                  }
                }
              } else if (!isAttack && !isReinforcment) {

                if (linkedTerritory && linkedTerritory.territoryRuler === currentPlayer) {
    
                  const foundTerritory = territoryBoardDataExport.find(
                    (territory) => territory.id === territoryId && territory.troopsCount > 1
                  );
                      
                  if (foundTerritory) {
                    
                    fortifiableTerritories.push({
                      fortifiableTerritory: linkedTerritory,
                      associatedTerritory: foundTerritory
                    });
                    
                  } else {
                    //console.log("No fortifiable territory found for territoryId:", territoryId);
                  }
                } else {
                  //console.log("Conditions not met for territory:", linkedTerritory);
                }
              }
            });
          });
        }
      });
      //console.log("Fortifiable territories:", fortifiableTerritories);
      return fortifiableTerritories;
    };    

    //=============================================>
    // Function to show Error Status Notification
    //=============================================>
    const showErrorNotification = (messageTxt) => {
      window.alert(messageTxt);
    };

    //====================================>
    // Function to modify dice values
    //====================================>
  /*  const updateDiceValues = (attackerDiceValue, defenderDiceValue) => {
      // Check if the ref has been initialized
      if (battleScreenRef.current) {
        // Call the update functions of the BattleScreen component using the ref
        console.log('Battle Screen Update Dice Value Called');
        battleScreenRef.current.updateAttackerDiceValue(attackerDiceValue);
        battleScreenRef.current.updatedefenderDiceValue(defenderDiceValue);
      }
    }; */

    //#endregion

    executeBotAIExport = executeBotAI;
    updateAIActiveStatusExport = updateAIActiveStatus;

    return(
      
      <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', pointerEvents: 'none' }}>
        {/* Your transparent div content goes here */}
      </div>
    );

};

//export {executeBotAIExport};
export { executeBotAIExport, updateAIActiveStatusExport };

export default AIController;
  